module.exports = __webpack_public_path__ + "img/icon-white-41.0b657cd3.svg";